import moment from "moment";

export default class TransactionModel {
    constructor() {
        this.petraId = undefined
        this.cardNumber = '';
        this.registrationNumber = '';
        this.odometer = '';
        this.stationNumber = '';
        this.amount = undefined;
        this.amountNet = undefined;
        this.amountVat = undefined;
        this.date = undefined;
        this.dateTime = undefined;
        this.stationAddress = '';
        this.safoId = undefined;
        this.petraStationId = undefined;
        this.driver = '';
        this.positions = undefined;
        this.editable = undefined;
        this.electromobility = undefined;
        this.quantity = undefined;
        this.transactionType = undefined;
    }

    static assign(from, to) {
        if (from) {
            to.petraId = from.petraId ? from.petraId : undefined;
            to.cardNumber = from.cardNumber ? from.cardNumber : ''
            to.registrationNumber = from.registrationNumber ? from.registrationNumber : '';
            to.odometer = from.odometer ? from.odometer : '';
            to.stationNumber = from.stationNumber ? from.stationNumber : '';
            to.amount = from.amount ? from.amount : undefined;
            to.amountNet = from.amountNet ? from.amountNet : undefined;
            to.amountVat = from.amountVat ? from.amountVat : undefined;
            to.date = from.date ? moment(from.date).format('DD-MM-YYYY') : undefined;
            to.dateTime = from.dateTime ? moment(from.dateTime).format('DD-MM-YYYY HH:mm:ss') : undefined;
            to.stationAddress = from.stationName ? from.stationName : '';
            to.safoId = from.safoId ? from.safoId : undefined;
            to.petraStationId = from.petraStationId ? from.petraStationId : undefined;
            to.driver = from.driver ? from.driver : '';
            to.positions = from.positions ? from.positions : undefined;
            to.editable = from.editable ? from.editable : false;
            to.electromobility = from.electromobility ? from.electromobility : false;
            to.quantity = from.quantity ? from.quantity : false;
            to.transactionType = from.transactionType ? from.transactionType : undefined;

        } else {
            to = new TransactionModel();
        }
    }

    static copy(from) {
        const to = new TransactionModel();
        TransactionModel.assign(from, to);
        return to;
    }
}